// extracted by extract-css-chunks-webpack-plugin
module.exports = {"size":"GFRcw5AHW2xL2F_TZia2"};